import React, { useState } from "react";

import Modal from "../ui/Modal";
import { FileText } from "lucide-react";

const SummaryCell = ({ text, title = "Full Summary" }) => {
  const [open, setOpen] = useState(false);



  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <div className="summary-cell" onClick={() => setOpen(true)}>
        <span className="summary-icon-container">
          <FileText size={14} className="summary-icon" />
        </span>
        <span className="summary-text">
          {text}
        </span>
      </div>

      {/* Modal */}
      <Modal
  title={title}
  isOpen={open}
  onClose={handleClose}
 
>
<div className="summary-modal-content">
  <div className="summary-text-box">
    {text}
  </div>
</div>
  </Modal>
    </>
  );
};


export default SummaryCell;